module.exports = __webpack_public_path__ + "static/media/essayboi.94a9adac.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/essayboi.PNG
// module id = 87
// module chunks = 0